import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { FileText } from 'lucide-react';
export function Terms() {
  return <div className="min-h-screen flex flex-col bg-white" data-id="element-775">
      <Header data-id="element-776" />
      <main className="flex-grow" data-id="element-777">
        <section className="py-20 bg-gradient-to-br from-[#0D7377] to-[#14919B] text-white" data-id="element-778">
          <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-779">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white bg-opacity-20 rounded-full mb-6" data-id="element-780">
              <FileText size={32} data-id="element-781" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-782">
              Terms & Conditions
            </h1>
            <p className="text-xl text-gray-100" data-id="element-783">
              Please read these terms carefully before using our services
            </p>
          </div>
        </section>
        <section className="py-16 bg-white" data-id="element-784">
          <div className="max-w-4xl mx-auto px-4" data-id="element-785">
            <div className="prose prose-lg max-w-none" data-id="element-786">
              <div className="bg-gray-50 p-6 rounded-xl mb-8" data-id="element-787">
                <p className="text-sm text-gray-600" data-id="element-788">
                  <strong data-id="element-789">Company:</strong> Caringhand
                  <br data-id="element-790" />
                  <strong data-id="element-791">Address:</strong> 157 Ashley Rd, Hale, Altrincham WA15
                  9SD
                  <br data-id="element-792" />
                  <strong data-id="element-793">Email:</strong> info@caringhand.it.com
                  <br data-id="element-794" />
                  <strong data-id="element-795">Phone:</strong> 0800 055 4969
                </p>
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-796">
                1. Services Provided
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-797">
                Caringhand provides domestic appliance diagnostics, repair, and
                maintenance services for washing machines, dishwashers, tumble
                dryers, cookers, fridges, freezers, and televisions across the
                UK mainland.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-798">
                2. Booking & Payment
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-799">
                Payment is due at the time of booking through our secure Stripe
                payment gateway. You will receive a confirmation email once
                payment has been successfully processed. This email serves as
                your booking confirmation and contains important details about
                your service.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-800">
                3. Diagnostics & Assessment
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-801">
                The diagnostics fee is earned once our qualified engineer has
                completed the assessment of your appliance and identified the
                fault. Following diagnostics, we will provide a clear
                explanation of the issue and a quote for any parts and
                additional labour required to complete the repair.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-802">
                4. Parts & Additional Labour
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-803">
                Any parts required for repair will be quoted separately and must
                be approved by you before we proceed. Additional labour beyond
                the initial diagnostics visit will also be quoted and requires
                your approval. We only fit parts that are appropriate for your
                appliance and available through our suppliers.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-804">
                5. Workmanship Assurance
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-805">
                We stand behind the quality of our work. If a fault recurs
                within 90 days of our repair due to our workmanship, we will
                return to assess and rectify the issue at no additional labour
                charge. This assurance does not extend to new faults, parts
                failure, misuse, or issues caused by factors outside our
                control.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-806">
                6. Service Exclusions
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-807">
                Our services do not cover:
              </p>
              <ul className="list-disc pl-6 mb-4 text-gray-700 space-y-2" data-id="element-808">
                <li data-id="element-809">Pre-existing faults that were present before our visit</li>
                <li data-id="element-810">
                  Damage caused by misuse, neglect, or improper installation
                </li>
                <li data-id="element-811">
                  Repairs carried out by unauthorised third parties after our
                  visit
                </li>
                <li data-id="element-812">Non-standard modifications or adaptations to appliances</li>
                <li data-id="element-813">Commercial or non-domestic use of appliances</li>
                <li data-id="element-814">Appliances beyond economical repair</li>
              </ul>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-815">
                7. Access & Safety
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-816">
                You must provide safe and reasonable access to the appliance
                requiring repair. If our engineer determines that the working
                environment is unsafe or that access is restricted, we reserve
                the right to postpone the visit until conditions improve. The
                diagnostics fee remains payable.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-817">
                8. Liability
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-818">
                Our liability is limited to the cost of the service you have
                paid for. We are not liable for indirect losses, consequential
                damages, or losses arising from appliance downtime. Nothing in
                these terms excludes our liability for death or personal injury
                caused by our negligence, fraud, or any other liability that
                cannot be excluded by law.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-819">
                9. Force Majeure
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-820">
                We are not liable for delays or failure to perform our services
                due to circumstances beyond our reasonable control, including
                but not limited to severe weather, natural disasters, strikes,
                or government restrictions.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-821">
                10. Governing Law
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-822">
                These terms and conditions are governed by the laws of England
                and Wales. Any disputes will be subject to the exclusive
                jurisdiction of the courts of England and Wales.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-823">
                11. Changes to Terms
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-824">
                We reserve the right to update these terms at any time. Changes
                will be posted on this page with an updated revision date.
                Continued use of our services after changes constitutes
                acceptance of the modified terms.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-825">
                12. Contact Us
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-826">
                If you have any questions about these terms and conditions,
                please contact us:
              </p>
              <div className="bg-gray-50 p-6 rounded-xl" data-id="element-827">
                <p className="text-gray-700 mb-2" data-id="element-828">
                  <strong data-id="element-829">Email:</strong> info@caringhand.it.com
                </p>
                <p className="text-gray-700 mb-2" data-id="element-830">
                  <strong data-id="element-831">Phone:</strong> 0800 055 4969
                </p>
                <p className="text-gray-700" data-id="element-832">
                  <strong data-id="element-833">Address:</strong> 157 Ashley Rd, Hale, Altrincham WA15
                  9SD
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-834" />
    </div>;
}